import axios from 'axios'

const api = `${process.env.VUE_APP_API_URL}/wp-json/v1/`

export function getPosts(payload) {
    const url = `${api}posts`

    return axios({
            method: 'get',
            url,
            params: payload
        })
        .then(response => response.data)
}

export function getFilters(payload) {
    const url = `${api}filters`
    return axios({
            method: 'get',
            url,
            params: payload
        })
        .then(response => response.data)
}

export function getContact(payload) {
    const url = `${api}contact`
    return axios({
            method: 'get',
            url,
            params: payload
        })
        .then(response => response.data)
}

export function getLocale(payload) {
    const url = `${api}locale`
    return axios({
            method: 'get',
            url,
            params: payload
        })
        .then(response => response.data)
}

export function getPost({
    id,
    slug,
    type,
    taxonomy,
    locale = 'en'
}) {
    const url = `${api}post`
    return axios({
            method: 'get',
            url,
            params: {
                id,
                slug,
                type,
                taxonomy,
                lang: locale
            }
        })
        .then(response => response.data)
}


export function getPage({
    id,
    locale = 'en'
}) {
    const url = `${api}page`
    return axios({
            method: 'get',
            url,
            params: {
                id,
                lang: locale
            }
        })
        .then(response => response.data)
}

export function fetchRSS(feed = 'http://feed.meltwater.com/gyda/outputs/xml/html/32/67/v2_415025.html.rss') {
    return axios.get(feed).then(({
        data
    }) => {
        // var $xml = (new DOMParser).parseFromString(data, "text/xml");
        let reItem = new RegExp(/<item>(.+?)<\/item>/g)
        let reTitle = new RegExp(/<title>(.+?)<\/title>/)
        let reLink = new RegExp(/<link>(.+?)<\/link>/)
        let reCDATA = new RegExp(/\<\!\[CDATA\[(.+\]{0}\>{0})\]\]\>/g)
        var m = data.match(reItem).map(_ => {
            return {
                title: _.match(reTitle)[1].replace(reCDATA, (a, b) => {
                    return b
                }),
                link: _.match(reLink)[1]
            }
        })
        return m
    })
}